import PropTypes from 'prop-types';
import React from 'react';

const guessRuleLabel = ruleId => {
  if (!ruleId) return '';
  const label = ruleId.replace(/_/g, ' ').toLowerCase();
  return label.charAt(0).toUpperCase() + label.slice(1);
};

// todo add final styles
function RuleWidget({ type }) {
  return <div>{guessRuleLabel(type)}</div>;
}

RuleWidget.propTypes = {
  type: PropTypes.string.isRequired,
};

export default RuleWidget;
